import * as React from "react";
import TextareaHybrid from "./TextareaHybrid";
import type { TypeTextareaProps } from "./TextareaTypes";

/**
 * @deprecated Use TypeTextareaProps from root instead
 */
export type TypeProps = TypeTextareaProps;

/**
 * Textarea component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension).
 */
const Textarea = React.forwardRef<HTMLTextAreaElement, TypeTextareaProps>(
  (props, ref) => <TextareaHybrid {...props} ref={ref} />
);

Textarea.displayName = "Textarea";
export default Textarea;
